export const IMAGE = "Image"
export const PARAGRAPH = "Paragraph"
export const ITEM = "Item"
export const SIDE_BY_SIDE = "side_by_side"